const ADDR_ID_PREFIX="file_complaint_step2_complaint_fieldset_"

const addAddressSearch = type => {
  document.addEventListener('DOMContentLoaded', () => {
    
  const complaintForm = document.querySelector('form#new_complaint');
  const addressSearchInput = complaintForm.querySelector(
    `#${ADDR_ID_PREFIX}${type}_addresses_address1`,
  );
  const resultArea = complaintForm.querySelector(`#${type}-address-results-area`);
  const formSubmitButton = complaintForm.querySelector('button[type="submit"]');
  const clearSearchButton = complaintForm.querySelector('#clear-search-button');
  let _changeInterval = null;

  const addressSearch = e => {
    clearInterval(_changeInterval);
    _changeInterval = setInterval(function() {
      clearInterval(_changeInterval);
    }, 2000);

    const search_value = $(`#${ADDR_ID_PREFIX}${type}_addresses_address1`).val();
    if (search_value.length < 5 && search_value.length > 0) {
      $(`.${type}-address-results`).show();
      return;
    } else if(search_value.length === 0) {
      return;
    }

    return $.post(
      '/autocomplete/address_lookup',
      {query: search_value},
      function(data) {
        $(`#${type}-address-results-area`).html(data);
        $(`#${type}-address-results-area`).on('click', '.address-result', function() {
          return selectAddress($(this));
        });
        return $(`.${type}-address-results`).show();
      }
    );
  };

  const selectAddress = function(address_result) {
    if (
      typeof address_result.attr('id') === undefined ||
      typeof address_result === undefined
    ) {
      return;
    }

    unitNames = [
      "Apt",
      "Bsmt",
      "Bldg",
      "Dept",
      "Fl",
      "Frnt",
      "Hngr",
      "Key",
      "Lbby",
      "Lot",
      "Lowr",
      "Ofc",
      "Ph",
      "Pier",
      "Rear",
      "Rm",
      "Side",
      "Slip",
      "Spc",
      "Stop",
      "Ste",
      "Trlr",
      "Unit",
      "Uppr"
    ]

    states = {
      'AL': 'Alabama',
      'AK': 'Alaska',
      'AS': 'American Samoa',
      'AZ': 'Arizona',
      'AR': 'Arkansas',
      'CA': 'California',
      'CO': 'Colorado',
      'CT': 'Connecticut',
      'DE': 'Delaware',
      'DC': 'District Of Columbia',
      'FM': 'Federated States Of Micronesia',
      'FL': 'Florida',
      'GA': 'Georgia',
      'GU': 'Guam',
      'HI': 'Hawaii',
      'ID': 'Idaho',
      'IL': 'Illinois',
      'IN': 'Indiana',
      'IA': 'Iowa',
      'KS': 'Kansas',
      'KY': 'Kentucky',
      'LA': 'Louisiana',
      'ME': 'Maine',
      'MH': 'Marshall Islands',
      'MD': 'Maryland',
      'MA': 'Massachusetts',
      'MI': 'Michigan',
      'MN': 'Minnesota',
      'MS': 'Mississippi',
      'MO': 'Missouri',
      'MT': 'Montana',
      'NE': 'Nebraska',
      'NV': 'Nevada',
      'NH': 'New Hampshire',
      'NJ': 'New Jersey',
      'NM': 'New Mexico',
      'NY': 'New York',
      'NC': 'North Carolina',
      'ND': 'North Dakota',
      'MP': 'Northern Mariana Islands',
      'OH': 'Ohio',
      'OK': 'Oklahoma',
      'OR': 'Oregon',
      'PW': 'Palau',
      'PA': 'Pennsylvania',
      'PR': 'Puerto Rico',
      'RI': 'Rhode Island',
      'SC': 'South Carolina',
      'SD': 'South Dakota',
      'TN': 'Tennessee',
      'TX': 'Texas',
      'UT': 'Utah',
      'VT': 'Vermont',
      'VI': 'Virgin Islands',
      'VA': 'Virginia',
      'WA': 'Washington',
      'WV': 'West Virginia',
      'WI': 'Wisconsin',
      'WY': 'Wyoming'
    }

    addressRegex = new RegExp("(?="+unitNames.join(')|(?=')+")")
    endingRegex = new RegExp("([A-Z]{2})")

    const updateAddressForm = address_info => {
      parsed = address_info.split(",");
      ending = parsed[1].split(endingRegex);
      street = parsed[0].split(addressRegex);
      document.querySelector(`#${ADDR_ID_PREFIX}${type}_addresses_address1`).value = street[0].trim();
      if (street[1] !== undefined){
        document.querySelector(`#${ADDR_ID_PREFIX}${type}_addresses_address2`).value = street[1].trim();
      }
      document.querySelector(`#${ADDR_ID_PREFIX}${type}_addresses_city`).value = ending[0].trim();

      // Since implemented, this translated the state code from the API to the state name. But in 
      // Sept it was requested that this be the two digit version only.
      document.querySelector(`#${ADDR_ID_PREFIX}${type}_addresses_state`).value = ending[1].trim(); //states[ending[1]];
      document.querySelector(`#${ADDR_ID_PREFIX}${type}_addresses_zip`).value = ending[2].trim();
    };

    const addressInformation = getNodeList(address_result)
        .map(element => stripNewlines(element.innerText))
        .join(' ');

    addressSearchInput.value = addressInformation;
    updateAddressForm(address_result.attr('id'));
    resultArea.style.display = 'none';
  };

  const getNodeList = element => {
    if (element.childNodes === undefined) {
      return [...element[0].childNodes];
    } else {
      return [...element.childNodes];
    }
  };

  const stripNewlines = string => {
    return string.replace(/(\r\n|\n|\r)/gm, '');
  };

  if(addressSearchInput) {
    addressSearchInput.addEventListener('keyup', addressSearch);
  }
  });
}

if ($('form#new_complaint').length) {  
  if ($('.home-address-results').length) {
    addAddressSearch("home");
  }
  
  if ($('.alternate-address-results').length) {
    addAddressSearch("alternate");
  }
  
}